import React, { FC } from 'react'

import { IconSmallAndLightweightProps } from './IconSmallAndLightweight.types'
import * as Styled from './styles/IconSmallAndLightweight.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSmallAndLightweight: FC<IconSmallAndLightweightProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSmallAndLightweightProps['size'],
  isResponsive = false,
}: IconSmallAndLightweightProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M18.734 20.5c4.578-.691 12.23-3.203 16.266-12.086C36.121 5.95 37.582 5 39.168 5c0 0 3.832-.25 3.832 8.25 0 5.574-2.7 19.2-18.45 25.45'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M18.734 20.5c4.578-.691 12.23-3.203 16.266-12.086C36.121 5.95 37.582 5 39.168 5c0 0 3.832-.25 3.832 8.25 0 5.574-2.7 19.2-18.45 25.45'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M8.172 30.32 15 20.742' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M8.172 30.32 15 20.742' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M8.172 30.32S11.25 38.75 21.25 42' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M8.172 30.32S11.25 38.75 21.25 42' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M16 35.129s7.629 4.785 16.5 4.621' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M16 35.129s7.629 4.785 16.5 4.621' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M15 27.25A43.1 43.1 0 0 0 20.059 17' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M15 27.25A43.1 43.1 0 0 0 20.059 17' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M4.941 29.656c5.036 1.285 24.903 5 32.25-14.156'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M4.941 29.656c5.036 1.285 24.903 5 32.25-14.156'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSmallAndLightweight
